import {
    createContext,
    useContext,
    useReducer,
    useMemo,
} from 'react';

export const SiteInfoContext = createContext(null);

export const useSiteInfo = () => {
    return useContext(SiteInfoContext);
};

const siteInfoReducer = (state, action) => {
    switch (action.type) {
    case 'SET_AGENT_ID':
        return { ...state, agentId: action.value };
    case 'TOGGLE_SHOW_REGISTER':
        return { ...state, isShowRegister: !state.isShowRegister };
    case 'SET_IS_SHOW_CASH_MEMBER_JOIN_NOW_BUTTON':
        return { ...state, isShowCashMemberJoinNowButton: action.value };
    case 'SET_IS_SHOW_JOIN_NOW_BUTTON':
        return { ...state, isShowJoinNowButton: action.value };
    case 'SET_IS_CASH_SITE':
        return { ...state, isCashSite: action.value };
    case 'SET_CASH_SITE_INFO':
        return { ...state, cashSiteInfo: action.value };
    default:
        return state;
    }
};

export const SiteInfoProvider = ({ children, siteInfo }) => {
    const initialState = {
        isShowRegister: false,
        isShowCashMemberJoinNowButton: false,
        isShowJoinNowButton: false,
        isCashSite: false,
        cashSiteInfo: {},
        ...(siteInfo || {}),
    };
    const [state, dispatch] = useReducer(siteInfoReducer, initialState);

    const setAgentId = (agentId) => {
        dispatch({ type: 'SET_AGENT_ID', value: agentId });
    };

    const toggleShowRegister = () => {
        dispatch({ type: 'TOGGLE_SHOW_REGISTER' });
    };

    const setIsShowCashMemberJoinNowButton = (isShowCashMemberJoinNowButton) => {
        dispatch({ type: 'SET_IS_SHOW_CASH_MEMBER_JOIN_NOW_BUTTON', value: isShowCashMemberJoinNowButton });
    };

    const setIsShowJoinNowButton = (isShowJoinNowButton) => {
        dispatch({ type: 'SET_IS_SHOW_JOIN_NOW_BUTTON', value: isShowJoinNowButton });
    };

    const setIsCashSite = (isCashSite) => {
        dispatch({ type: 'SET_IS_CASH_SITE', value: isCashSite });
    };

    const setCashSiteInfo = (cashSiteInfo) => {
        dispatch({ type: 'SET_CASH_SITE_INFO', value: cashSiteInfo });
    };

    const contextValue = useMemo(
        () => ({
            ...state,
            dispatch,
            setAgentId,
            toggleShowRegister,
            setIsShowCashMemberJoinNowButton,
            setIsShowJoinNowButton,
            setIsCashSite,
            setCashSiteInfo,
        }),
        [state],
    );

    return (
        <SiteInfoContext.Provider value={contextValue}>
            {children}
        </SiteInfoContext.Provider>
    );
};
